import cookie from 'react-cookies';
import { CookieDataType, CookieDataExtendType } from './type.d';

export const subscribeCookie = ({ entry_name, sector_name, entry_position }: CookieDataExtendType) => {
    if (typeof window === 'undefined') return {} as CookieDataType;
    const { href, hostname } = window.location;
    const source_channel = 'Website';
    const obj: CookieDataType = {
        page_url: href,
        source_channel,
    };
    if (entry_name) {
        obj.entry_name = entry_name;
    }
    if (sector_name) {
        obj.sector_name = sector_name;
    }
    if (entry_position) {
        obj.entry_position = entry_position;
    }
    const arr = window.location.pathname.split('/');
    const locale = arr?.length >= 1 ? arr[1] : 'us';
    cookie.remove('subscribe_info', {
        domain: hostname.endsWith('.ecoflow.com') ? '.ecoflow.com' : hostname,
        path: `/${locale}`,
    });
    cookie.save('subscribe_info', obj, {
        domain: hostname.endsWith('.ecoflow.com') ? '.ecoflow.com' : hostname,
        path: `/${locale}`,
        expires: new Date(Date.now() + 3600 * 1000 * 24 * 7),
    });
    return obj;
};
